/**
 * The one coercion every money cell goes through (LLAMS-610 KIND-01). A host sends amounts as
 * numbers, as numeric strings ("3680"), as formatted strings ("$3,680.00", "($184.00)") or not at
 * all; feeding any of those straight into `Intl.NumberFormat` printed "$NaN". Returns a finite
 * number, or `null` when there is no usable amount — callers print an em dash for `null`.
 */
export function toMoneyAmount(value: unknown): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;

  const text = value.trim();
  if (!text) return null;

  const negative = /^\(.*\)$/.test(text) || /^[^\d]*-/.test(text);
  // A lone comma followed by one or two digits is a decimal comma ("3680,50"); otherwise commas group thousands.
  const decimalComma = /^[^\d]*\d+,\d{1,2}[^\d]*$/.test(text) && !text.includes('.');
  const digits = (decimalComma ? text.replace(',', '.') : text.replace(/,/g, '')).replace(/[^\d.]/g, '');
  if (!/\d/.test(digits)) return null;

  const parsed = Number(digits);
  if (!Number.isFinite(parsed)) return null;
  return negative ? -parsed : parsed;
}
